export const PLUSKEY = 187;
export const MINUSKEY = 189;
export const DOWNKEY = 40;
export const SPACEKEY = 32;
export const ESCKEY = 27;
export const LEFTKEY = 37;
export const RIGHTKEY = 39;
export const TABKEY = 9;
export const UPKEY = 38;
